import lodash from 'lodash';

class FilterUtil {
  whitelist(data, whitelist) {
    if (!data) {
      return {};
    }
    const result = data.filter((item) => {
      for (const key in item) {
        if (whitelist.indexOf(key) <= -1) {
          delete item[key];
        }
      }
      return item;
    });
    return result;
  }

  whitelistAsClone(data, whitelist) {
    const dataCloned = lodash.cloneDeep(data);
    return this.whitelist(dataCloned, whitelist);
  }
}

export default new FilterUtil();
